import React, { useContext } from "react";
import { Container } from "react-bootstrap";
import SearchField from "../components/SearchField";
import { FilterContext } from "contextos/FilterContext";

export default function HeaderSection(props) {
  const { title } = props;
  const { handleSearchBarSubmit } = useContext(FilterContext);

  return (
    <div className="c-top-header-section">
      <Container>
        <div className="c-top-header-container">
          <div className="c-top-header-title d-none d-lg-flex">
            <h1>{title}</h1>
          </div>
          <div className="c-searchfiel c-top-header-title">
            <form
              action={``}
              onSubmit={handleSearchBarSubmit}
              name="searchForm"
              id="btnFulltext"
            >
              <SearchField />
            </form>
          </div>
        </div>
      </Container>
    </div>
  );
}
